import { FC, useMemo } from 'react'
import { FetchState, useModal } from '../../../../../../components'
import { useAuth } from '../../../../../auth'
import { temVinculoMedicoAtivoNaEmpresa } from 'app/modules/auth/core/vinculos'
import { FormularioAtendimentoView } from '../../../avaliacoes-list/core/_models'
import DOMPurify from 'dompurify'

export type IModal = {
  data?: FormularioAtendimentoView | undefined
}

export const FormularioViewModal: FC<IModal> = ({ data }) => {
  const { fetchStates } = useModal()
  const { currentUser } = useAuth()

  const { data: formulario } = (fetchStates['formulario'] ||
    {}) as FetchState<FormularioAtendimentoView>

  const empresaId = formulario?.paciente?.empresa?.id ?? data?.paciente?.empresa?.id

  const isMedico = temVinculoMedicoAtivoNaEmpresa(currentUser?.vinculos, empresaId)

  const lista = useMemo(
    () =>
      formulario?.respostas && formulario?.respostas.length > 0
        ? formulario?.respostas
        : data?.respostas ?? [],
    [formulario, data]
  )

  if (!isMedico) {
    return (
      <p className='text-muted'>Apenas médicos podem visualizar as respostas desta avaliação.</p>
    )
  }

  if (!lista || lista.length === 0) {
    return <p className='text-muted'>A avaliação não foi respondida</p>
  }

  return (
    <>
      {lista?.map((item) => {
        const hasValor =
          item.valor !== undefined &&
          item.valor !== null &&
          item.valor !== '' &&
          item.valor !== 'undefined'

        const hasValores = Array.isArray(item.valores) && item.valores.length > 0

        return (
          <div key={item.id} className='mb-4'>
            <h6>{item.campo}</h6>

            {hasValor && <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.valor) }} />}

            {hasValores && (
              <ul className='pl-3'>
                {item.valores.map((valor, index) => (
                  <li key={index}>{valor}</li>
                ))}
              </ul>
            )}

            {!hasValor && !hasValores && <p className='text-muted'>Sem Resposta</p>}
          </div>
        )
      })}
    </>
  )
}
